export const projectData = [
	{
		id: 1,
		projectName: "WIP: Time Capsule App (for my Daughter)",
		projectDescription: "A little side hobby application of mine to store precious moments of my daughter",
		stack: "AWS Serverless (Lambda, DynamoDB, Cognito), React.js, GSAP",
		link: "https://github.com/giorgigutsaevi/lile-app",

	},
	{
		id: 2,
		projectName: "Recipr",
		projectDescription: "A classic recipe app built with MERN.",
		stack: "React.js, Node.js, Express, MongoDB, Mongoose.",
		link: "https://github.com/giorgigutsaevi/recipr-mern",

	},
	{
		id: 3,
		projectName: "Movie Search App",
		projectDescription: "The app uses the Movie Database API to search for movies based on the user's search query.",
		stack: "React.js, Axios, Bootstrap CSS.",
		link: "https://github.com/giorgigutsaevi/react-movie-search-app",
	},
	{
		id: 4,
		projectName: "React Notes App",
		projectDescription: "A classic Notes application built with React.js.",
		stack: "React.js, Bootstrap CSS.",
		link: 'https://github.com/giorgigutsaevi/react-notes-app'
	},
	{
		id: 5,
		projectName: "Wormz",
		projectDescription: "Final project at Makers Academy. Wormz is a browser shooting game.",
		stack: "Node.js, Matter.js, Express.js, p5.js, Mocha, Chai.",
		link: 'https://github.com/giorgigutsaevi/wormz'
	},
	{
		id: 6,
		projectName: "Acebook",
		projectDescription: "A group project at Makers Academy. Acebook is a facebook clone.",
		stack: "Ruby on Rails, JavaScript, OAuth, Devise, Bulma.",
		link: 'https://github.com/giorgigutsaevi/acebook-ruby-junkies'
	},
	{
		id: 7,
		projectName: "Chitter",
		projectDescription: "A Twitter Clone, where users can sign up, sign in and share their tweets.",
		stack: "Ruby, Sinatra, Rspec, Capybara, PostgreSQL, Bootstrap CSS.",
		link: 'https://github.com/giorgigutsaevi/chitter-challenge',
	},
	{
		id: 8,
		projectName: "Rock, Paper, Scissors",
		projectDescription: "A Ruby/Sinatra web game, where the user plays vs a computer.",
		stack: "Ruby, Sinatra, Bootstrap CSS.",
		link: 'https://github.com/giorgigutsaevi/rps-challenge'
	},
]
